import * as React from 'react';
import Fuse from 'fuse.js';
import { debounce } from 'throttle-debounce';

import { IRegionOptionsGroup } from '../../../../components/LocationModal/mobile';
import { IRegion } from '../../../../types/regions';

export function useAvailableOptionGroups(
  defaultOptionGroups: IRegionOptionsGroup[],
  regions: IRegion[],
  queryRaw: string | null,
): IRegionOptionsGroup[] {
  const queryRef = React.useRef(queryRaw);
  queryRef.current = queryRaw;
  const [query, setQuery] = React.useState(queryRaw);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleQueryChange = React.useCallback(
    debounce(300, () => {
      setQuery(queryRef.current);
    }),
    [],
  );

  const fuse = React.useMemo(
    () =>
      new Fuse(regions, {
        includeMatches: true,
        findAllMatches: true,
        keys: ['name'],
      }),
    [regions],
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(handleQueryChange, [queryRaw]);

  return React.useMemo(() => {
    const trimmedQuery = query?.trim();

    if (!trimmedQuery) {
      return defaultOptionGroups || [];
    }

    return [
      {
        options: fuse.search(trimmedQuery).map(o => ({
          title: o.item.name,
          value: o.item.id,
          matches: o.matches && o.matches.length > 0 ? (o.matches[0].indices as [number, number][]) : undefined,
        })),
      },
    ];
  }, [defaultOptionGroups, fuse, query]);
}
